import React from "react";

import { bem } from "ComparePlans/styles";
import PropTypes from "prop-types";
import formatCurrency from "Utils/formatCurrency";

import BodyText from "Common/BodyText";
import { ContentRow } from "Common/Table";

import type { MedicalPlanPrice } from "Utils/types";

type Props = {
  plans: Array<MedicalPlanPrice>;
  isSampleQuote: boolean;
};

export default function AveragePremiumRow({ plans, isSampleQuote }: Props) {
  const heading = isSampleQuote ? (
    <BodyText size="large" muted>
      Employee Average <br />
      <BodyText componentClass="span" size="small" muted>
        * priced for one 30 year old employee
      </BodyText>
    </BodyText>
  ) : (
    <BodyText size="large" muted>
      Employee Average
    </BodyText>
  );

  return (
    <ContentRow
      className={bem("AveragePremiumRow")}
      heading={heading}
      cell={(plan) => (
        <BodyText size="large" componentClass="span" muted>
          {formatCurrency(plan.average_monthly_premium)}
          <BodyText componentClass="span" muted>
            /month
            {isSampleQuote ? "*" : ""}
          </BodyText>
        </BodyText>
      )}
      items={plans}
    />
  );
}

AveragePremiumRow.propTypes = {
  plans: PropTypes.array.isRequired,
  isSampleQuote: PropTypes.bool.isRequired,
};
